import React from "react";
import { getFormattedNumber, getYearFromDateStr } from "../utils/textUtils";
import Loader from "../Common/Loader";

const PurchaseProjection = ({ resPacket, loading }) => {
  const getTotalAmount = (_row) => {
    if (_row && !isNaN(_row.taxRate) && !isNaN(_row.amount)) {
      const taxRate = parseFloat(_row.taxRate);
      const amount = parseFloat(_row.amount);
      let taxAmount = (amount * taxRate) / 100;
      return (amount + taxAmount).toFixed(2);
    } else {
      return "NA";
    }
  };

  if (loading) {
    return <Loader />;
  }

  if (resPacket?.length === 0) {
    return "No Records Found";
  }

  return (
    <div className="customTable"  id="scroll">
      <table className="customTable w-100">
        <thead className="fixed-thead">
          <tr>
            <td>SNO.</td>
            <td>PO NUMBER</td>
            <td>PO DATE</td>
            <td>SUPPLIER CATEGORY</td>
            <td>SUPPLIER NAME</td>
            <td>CITY</td>
            <td>STATE</td>
            <td>ITEM CODE</td>
            <td>ITEM NAME</td>
            <td>ITEM CATEGORY</td>
            <td>ITEM SUB CATEGORY</td>
            <td className="text-center">QTY</td>
            <td>UOM</td>
            <td>ALT QTY</td>
            <td className="text-center">ITEM RATE</td>
            <td className="text-center">AMOUNT</td>
            <td className="text-center">TAX RATE</td>
            <td className="text-center">TOTAL AMOUNT</td>
          </tr>
        </thead>
        <tbody className="body-scroll-custom">
          {resPacket.map((row, i) => (
            <tr key={i}>
              <td>{i+1}</td>
              <td className="white-space-pre">{row.purchaseNumber}</td>
              <td className="white-space-pre">{row.purchaseDate}</td>
              <td>{row.supplierCategory}</td>
              <td>{row.supplierName}</td>
              <td>{row.city}</td>
              <td>{row.state}</td>
              <td>{row.itemCode}</td>
              <td>{row.itemName}</td>
              <td>{row.category}</td>
              <td>{row.subCategory}</td>
              <td className="text-right">{getFormattedNumber(row.qty)}</td>
              <td>{row.uom}</td>
              <td className="text-center">{row.altQTY}</td>
              <td className="text-right">{getFormattedNumber(row.rate)}</td>
              <td className="text-right">{getFormattedNumber(row.amount)}</td>
              <td className="text-right">{getFormattedNumber(row.taxRate)}</td>
              <td className="text-right">{getTotalAmount(row)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PurchaseProjection;
